import {
  AddressStatusChangeActivityV2,
  GroupTextActivityV2,
  TextActivityV2,
  ShowingRequestActivityV2,
  HomeValueActivityV2,
  ViewedPropertyActivityV2,
  QuestionsActivityV2,
  LeadTransferActivityV2,
  NewLeadActivityV2,
  TrackingTextActivity,
  TrackingVoicemailCallLogActivityV2,
  TrackingVoicemailPdpActivityV2,
  FavPropertyActivityV2,
  SavedSearchActivityV2,
  ReturnSiteActivityV2,
  NoteMentionActivityV2,
  NewTaskActivityV2,
  LeadEngagedWithChatbotActivityV2,
  SubmittedFormActivityV2,
  SellingPageVisitedActivityV2,
  ListingInquiryActivityV2,
  GabbiAgentNeededActivityV2,
  NewApplicantActivityV2,
  GabbiLoanCreatedActivityV2,
  LoanNotesUpdatedActivityV2,
  LoanStatusUpdatedActivityV2,
  ContactFormAskQuestionActivityV2,
  TrackingNumberMissedCallActivity,
  TrackingNumberCallActivity,
} from "./ActivitiesV2";
import LeadFromMailerActivity from "./ActivitiesV2/LeadFromMailerActivity";
import LeadFromDigitalAdActivity from "./ActivitiesV2/LeadFromDigitalAdActivity";
import EngagedWithAdActivity from "./ActivitiesV2/EngagedWithAdActivity";
import EngagedWithMailerActivity from "./ActivitiesV2/EngagedWithMailerActivity";

export const includeFeatureFlaggedKeys = (featureFlag, activities) => (featureFlag ? activities : {});

export const BATCH_1_ACTIVITIES = {
  assigned_task: { component: NewTaskActivityV2, category: "crm" },
  cma_requested: { component: SubmittedFormActivityV2, category: "requests" },
  contact_us: { component: SubmittedFormActivityV2, category: "requests" },
  contact_form_existing_lead: { component: SubmittedFormActivityV2, category: "requests" },
  contact_form_ask_a_question: { component: ContactFormAskQuestionActivityV2, category: "requests" },
  gabbi_loan_created: { component: GabbiLoanCreatedActivityV2, category: "crm" },
  loan_notes_updated: { component: LoanNotesUpdatedActivityV2, category: "crm" },
  loan_status_updated: { component: LoanStatusUpdatedActivityV2, category: "crm" },
  group_message: { component: GroupTextActivityV2, category: "text" },
  home_value_submitted: { component: HomeValueActivityV2, category: "requests" },
  lead_pond_contact_form_questions_about: { component: QuestionsActivityV2, category: "requests" },
  lead_pond_home_value_submitted: { component: HomeValueActivityV2, category: "requests" },
  lead_pond_home_value: { component: HomeValueActivityV2, category: "requests" },
  lead_pond_mention: { component: NoteMentionActivityV2, category: "crm" },
  lead_pond_property_viewed_x_times: { component: ViewedPropertyActivityV2, category: "web" },
  lead_pond_registration: { component: LeadTransferActivityV2, category: "crm" },
  lead_pond_return_after_30_days: { component: ReturnSiteActivityV2, category: "web" },
  lead_pond_transfer: { component: LeadTransferActivityV2, category: "crm" },
  lead_pond_schedule_showing: { component: ShowingRequestActivityV2, category: "requests" },
  lead_registration: { component: NewLeadActivityV2, category: "crm" },
  lead_return_after_30_days: { component: ReturnSiteActivityV2, category: "web" },
  lead_transfer: { component: LeadTransferActivityV2, category: "crm" },
  mention: { component: NoteMentionActivityV2, category: "crm" },
  new_applicant: { component: NewApplicantActivityV2, category: "recruiter" },
  property_viewed_x_times: { component: ViewedPropertyActivityV2, category: "web" },
  question_submitted: { component: QuestionsActivityV2, category: "requests" },
  saved_property: { component: FavPropertyActivityV2, category: "web" },
  lead_engaged_with_chatbot: { component: LeadEngagedWithChatbotActivityV2, category: "web" },
  saved_search: { component: SavedSearchActivityV2, category: "web" },
  schedule_showing: { component: ShowingRequestActivityV2, category: "requests" },
  sell_my_home_submitted: { component: SubmittedFormActivityV2, category: "requests" },
  text_message: { component: TextActivityV2, category: "text" },
  tracking_number_text: { component: TrackingTextActivity, category: "text" },
  tracking_number_voicemail: { component: TrackingVoicemailCallLogActivityV2, category: "text" },
  tracking_number_voicemail_from_contact: { component: TrackingVoicemailPdpActivityV2, category: "text" },
  tracking_number_missed_call_from_existing_contact: {
    component: TrackingNumberMissedCallActivity,
    category: "text",
  },
  tracking_number_missed_call_from_new_contact: {
    component: TrackingNumberMissedCallActivity,
    category: "text",
  },
  tracking_number_call: { component: TrackingNumberCallActivity, category: "text" },
  tracking_number_call_from_existing_contact: { component: TrackingNumberCallActivity, category: "text" },
  tracking_number_call_from_new_contact: { component: TrackingNumberCallActivity, category: "text" },
  tracking_number_missed_call: { component: TrackingNumberMissedCallActivity, category: "text" },
  unlock_equity_requested: { component: SubmittedFormActivityV2, category: "requests" },
  updated_home_value: { component: HomeValueActivityV2, category: "requests" },
  valuation_requested: { component: SubmittedFormActivityV2, category: "requests" },
  selling_page_visited: { component: SellingPageVisitedActivityV2, category: "web" },
  feedback_submitted: { component: SubmittedFormActivityV2, category: "requests" },
  contact_form_questions_about: { component: ListingInquiryActivityV2, category: "requests" },
  gabbi_agent_needed: { component: GabbiAgentNeededActivityV2, category: "ai" },
  lead_from_mailer: { component: LeadFromMailerActivity, category: "marketer" },
  lead_from_digital_ad: { component: LeadFromDigitalAdActivity, category: "marketer" },
  engaged_with_ad: { component: EngagedWithAdActivity, category: "marketer" },
  engaged_with_mailer: { component: EngagedWithMailerActivity, category: "marketer" },
};

export const ACTIVITIES_ADDRESS_LIST_FF = {
  lead_property_status_change: { component: AddressStatusChangeActivityV2, category: "crm" },
};

export const ACTIVITIES_FEED_TEST_FF = {
  sell_my_home_submitted_market_report: { component: SubmittedFormActivityV2, category: "requests" },
  adjusted_equity_calculator: { component: SubmittedFormActivityV2, category: "requests" },
  prequalification_request: { component: SubmittedFormActivityV2, category: "requests" },
  get_prequalified: { component: SubmittedFormActivityV2, category: "requests" },
  contact_form_general: { component: SubmittedFormActivityV2, category: "requests" },
};
